import { CSSProperties } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { UrlActionButtons } from '@shared/components/UrlActionButtons';
import { View } from '@shared/components/View';
import { Link } from '@shared/components/link';
import { AnchoredTooltip } from '@shared/components/tooltip';
import { TruncateLink } from '@shared/components/truncate';
import { UrlField } from '@shared/data/entity/fields/UrlField';
import { grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: UrlField;
  style?: StyleProp<ViewStyle>;
  textStyle?: CSSProperties;
}

export function UrlCollectionViewField({ field, style, textStyle }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={style}>
      <View row centerVertically>
        <View centerVertically style={{ flexShrink: 1 }}>
          <AnchoredTooltip tooltip={field.url}>
            <Link href={field.url}>
              <TruncateLink href={field.url} style={textStyle} />
            </Link>
          </AnchoredTooltip>
        </View>
        <UrlActionButtons url={field.url} showOpen={false} style={{ marginLeft: grid(1) }} />
      </View>
    </CardCollectionViewFieldContainer>
  );
}
